<template>
	<div>
		<template v-if="table">
			<div class="flex" style="align-items: center;">
				<template v-if="row">
					<el-tag v-if="row.sonflowstatus==0" effect="dark" type="danger" size="mini"
						style="margin-right: 4px;cursor: pointer;" @click="dataflow">子</el-tag>
					<el-tag v-if="row.sonflowstatus==1" effect="dark" type="success" size="mini"
						style="margin-right: 4px;cursor: pointer;" @click="dataflow">子</el-tag>
				</template>
				<el-link v-if="value==0" type="danger" style="font-size:12px" @click="dataflow">{{valuetext}}</el-link>
				<el-link v-if="value==1" type="success" style="font-size:12px" @click="dataflow">{{valuetext}}</el-link>
				<div v-if="value==2" style="font-size:12px">{{valuetext}}</div>
				<el-link v-if="value==-1" type="primary" style="font-size:12px" icon="el-icon-edit-outline"
					@click="edit">
					{{valuetext}}
				</el-link>
			</div>
		</template>
		<template v-else>
			<div class="flex" style="align-items: center;">
				<el-select size="mini" :value="value" clearable transfer filterable placeholder="请选择" @change="change"
					multiple :collapse-tags="true">
					<el-option label="未结束" :value="0"></el-option>
					<el-option label="已结束" :value="1"></el-option>
					<el-option label="无流程" :value="2"></el-option>
					<el-option label="保存待发" :value="-1"></el-option>
				</el-select>
				<el-switch style="margin-left: 10px;" v-model="sonflow" active-text="子" @change="sonflowChnage">
				</el-switch>
			</div>
		</template>

		<!-- 		<vxe-modal v-model="flowdetail" title="流程详情" width="600" height="600" show-footer transfer>
			<template #default>
				<el-steps direction="vertical" :active="flowprogressContent.length-1" :space="80">
					<el-step v-for="(item,index) in flowprogressContent" :key="index" :title="item.title"
						:description="item.time">
					</el-step>
				</el-steps>
			</template>
			<template #footer>
				<vxe-button size="mini" status="warning" content="取回" @click="retrieve" style="margin-right: 10px;">
				</vxe-button>
				<vxe-button size="mini" content="返回" @click="flowdetail=false"></vxe-button>
			</template>
		</vxe-modal> -->

		<flowdetail-index v-if="row" ref="flowdetailIndex" :dataid="row.id" :moduleName="moduleName"
			@retrieve="retrieve" />

	</div>
</template>

<script>
	import inputBase from '@_system/components/base/input.js'
	import selectBase from '@_system/components/base/select.js'
	import flowdetailIndex from './flowdetail/index.vue'
	export default {
		mixins: [inputBase, selectBase],
		props: {
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				flowdetail: false,
				flowprogressContent: [],
				sonflow:null
			}
		},
		created() {

		},
		mounted() {

		},
		watch: {
			socketTimestamp() {
				let message = this.$store.state.system.websocketMessage
				if (message.event == 'NOTICE') {
					if (message.data.module == this.moduleName && message.data.dataid == this.row.id) {
						this.table.$parent.commitProxy('query')
					}
				}
			}
		},
		computed: {
			socketTimestamp() {
				return this.$store.state.system.socketTimestamp
			},
			valuetext() {
				if (this.value == 0) {
					return '未结束'
				} else if (this.value == 1) {
					return '已结束'
				} else if (this.value == 2) {
					return '无流程'
				} else if (this.value == -1) {
					return '保存待发'
				} else {
					return ''
				}
			}
		},
		methods: {
			sonflowChnage(e){
				this.listforeingKey.sonflow = e?1:0
				
			},
			edit() {
				this.$api.flowprogress.list({
					dataid: this.row.id,
					formname: this.moduleName,
					isdraft: 1
				}).then((data) => {
					let query = {
						name: this.moduleName,
						controlltype: 2,
						id: this.row.id,
						windowName: data.list.title,
						isflow: 1,
						flowprogressid: data.list.id
					}

					let res = this.$router.resolve({
						name: 'update',
						query: query
					})
					let win = window.open(res.href, this.moduleName + 'update',
						this.$store.state.system.windowConfig)
					win.location.reload(true)
				}, () => {

				})
			},
			dataflow() {
				this.$refs.flowdetailIndex.modal_show()
			},
			formBack() {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
				}
			},
			retrieve() {
				this.$confirm('是否确认取回', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.module.retrieve(window.config.app, this.moduleName, {
						id: this.row.id
					}).then(() => {
						this.flowdetail = false
						this.table.$parent.customreload()
					})
				}).catch(() => {
					//this.table.$parent.commitProxy('query')
				});
			}
		},
		components: {
			flowdetailIndex
		}
	}
</script>